/*
|--------------------------------------------------------------------------
| View Buckets
|--------------------------------------------------------------------------
*/

/**
 * View Buckets
 * Output bucket information to the console.
 * @namespace
 */

_$.viewBuckets = function(){
	
	var commonJS		= __gh__webApp.common,
	    hasBucketsProp = commonJS.isObjectPropertySet(__gh__coreData,"pageData.buckets"),
	    buckets 		= (hasBucketsProp) ? __gh__coreData.pageData.buckets : [],
	    totalBuckets	= buckets.length,
	    message		= "VIEW BUCKETS" + "\n";
	
	if (!totalBuckets){ console.log("There were no buckets found."); }
	
	for(var i=0; i < totalBuckets; i++){
	   var 	bucket 		= buckets[i],
	   		totalItems 	= commonJS.isObjectPropertySet(bucket,"items.main") ? bucket.items.main.length : 0,
	    	ads			= (commonJS.isObjectPropertySet(bucket,"ads") && !commonJS.isObjectEmpty(bucket.ads)) ? bucket.ads : {};
		
		message += "Index: " + i + "\n";
    	message += "Title: " + bucket.title + "\n";
    	message += "ID: " + bucket.id + "\n";
    	message += "Feed: " + bucket.feedURL + "\n";
    	message += "Total Items: " + totalItems + "\n";
	    	
	    if (ads){
		   	for (var slot in ads) {
			   	if (commonJS.isObject(ads[slot]) && commonJS.isObjectPropertySet(ads[slot],"view")){
				   	message += "Ad " + slot + ": " + ads[slot].view + "\n";
				   	continue;
			   	}
		   		message += "Ad " + slot + ": " + ads[slot] + "\n";
		   	} 
	    }
	    
	    message += "\n";
	   	
	   //debug.log("Title:"+bucket.title,"ID:"+bucket.id,"Feed:"+bucket.feedURL,"Total Items:"+totalItems);
	   //debug.log("Title:",bucket.title,"ID:",bucket.id,"Feed:",bucket.feedURL,"Total Items:",totalItems);
	}
	console.log(message);
	//debug.log(message);
};